import ScheduleTable from './ScheduleTable';

export default ScheduleTable;
